import { render, staticRenderFns } from "./VSuccess.vue?vue&type=template&id=2a145095&"
import script from "./VSuccess.vue?vue&type=script&lang=js&"
export * from "./VSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports